/**
 * Transaction process graph for reverse negotiation (provider-initiated bids):
 *   - reverse-negotiation
 *
 * Provider submits offer -> customer accepts/counters/declines/withdraws
 * -> payment (confirm + capture) -> deliver -> accept deliverable -> reviews
 */

/**
 * Transitions (must match process.edn)
 */
export const transitions = {
  PROVIDER_OFFER: 'transition/provider-offer',
  PROVIDER_WITHDRAW_OFFER: 'transition/provider-withdraw-offer',

  CUSTOMER_COUNTER_OFFER: 'transition/customer-counter-offer',
  CUSTOMER_DECLINE_OFFER: 'transition/customer-decline-offer',
  CUSTOMER_WITHDRAW_COUNTER: 'transition/customer-withdraw-counter',
  CUSTOMER_WITHDRAW_COUNTER_AFTER_COUNTER: 'transition/customer-withdraw-counter-after-counter',
  CUSTOMER_ACCEPT_OFFER: 'transition/customer-accept-offer',

  PROVIDER_ACCEPT_COUNTER: 'transition/provider-accept-counter',
  PROVIDER_COUNTER_OFFER: 'transition/provider-counter-offer',
  PROVIDER_DECLINE_COUNTER: 'transition/provider-decline-counter',
  PROVIDER_WITHDRAW_COUNTER: 'transition/provider-withdraw-counter',

  CONFIRM_PAYMENT: 'transition/confirm-payment',
  CONFIRM_PAYMENT_AFTER_REMINDER: 'transition/confirm-payment-after-reminder',
  PAYMENT_REMINDER_AFTER_15_MIN: 'transition/payment-reminder-after-15-min',
  EXPIRE_PAYMENT: 'transition/expire-payment',
  EXPIRE_PAYMENT_AFTER_REMINDER: 'transition/expire-payment-after-reminder',

  PROVIDER_MARK_DELIVERED: 'transition/provider-mark-delivered',
  OPERATOR_MARK_DELIVERED: 'transition/operator-mark-delivered',
  PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_1:
    'transition/provider-mark-delivered-from-delivery-reminder-day-1',
  PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_2:
    'transition/provider-mark-delivered-from-delivery-reminder-day-2',
  PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_3:
    'transition/provider-mark-delivered-from-delivery-reminder-day-3',
  PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_4:
    'transition/provider-mark-delivered-from-delivery-reminder-day-4',
  PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_5:
    'transition/provider-mark-delivered-from-delivery-reminder-day-5',
  OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_1:
    'transition/operator-mark-delivered-from-delivery-reminder-day-1',
  OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_2:
    'transition/operator-mark-delivered-from-delivery-reminder-day-2',
  OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_3:
    'transition/operator-mark-delivered-from-delivery-reminder-day-3',
  OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_4:
    'transition/operator-mark-delivered-from-delivery-reminder-day-4',
  OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_5:
    'transition/operator-mark-delivered-from-delivery-reminder-day-5',
  DELIVERY_REMINDER_DAY_1: 'transition/delivery-reminder-day-1',
  DELIVERY_REMINDER_DAY_2: 'transition/delivery-reminder-day-2',
  DELIVERY_REMINDER_DAY_3: 'transition/delivery-reminder-day-3',
  DELIVERY_REMINDER_DAY_4: 'transition/delivery-reminder-day-4',
  DELIVERY_REMINDER_DAY_5: 'transition/delivery-reminder-day-5',
  AUTO_CANCEL_AFTER_14_DAYS: 'transition/auto-cancel-after-14-days',
  AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_1:
    'transition/auto-cancel-after-14-days-from-delivery-reminder-day-1',
  AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_2:
    'transition/auto-cancel-after-14-days-from-delivery-reminder-day-2',
  AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_3:
    'transition/auto-cancel-after-14-days-from-delivery-reminder-day-3',
  AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_4:
    'transition/auto-cancel-after-14-days-from-delivery-reminder-day-4',
  AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_5:
    'transition/auto-cancel-after-14-days-from-delivery-reminder-day-5',

  CUSTOMER_ACCEPT_DELIVERABLE: 'transition/customer-accept-deliverable',
  CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_1:
    'transition/customer-accept-deliverable-from-received-reminder-day-1',
  CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_2:
    'transition/customer-accept-deliverable-from-received-reminder-day-2',
  CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_3:
    'transition/customer-accept-deliverable-from-received-reminder-day-3',
  CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_4:
    'transition/customer-accept-deliverable-from-received-reminder-day-4',
  CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_5:
    'transition/customer-accept-deliverable-from-received-reminder-day-5',
  DISPUTE: 'transition/customer-dispute',
  CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_1:
    'transition/customer-dispute-from-received-reminder-day-1',
  CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_2:
    'transition/customer-dispute-from-received-reminder-day-2',
  CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_3:
    'transition/customer-dispute-from-received-reminder-day-3',
  CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_4:
    'transition/customer-dispute-from-received-reminder-day-4',
  CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_5:
    'transition/customer-dispute-from-received-reminder-day-5',
  MARK_ORDER_RECEIVED_REMINDER_DAY_1: 'transition/mark-order-received-reminder-day-1',
  MARK_ORDER_RECEIVED_REMINDER_DAY_2: 'transition/mark-order-received-reminder-day-2',
  MARK_ORDER_RECEIVED_REMINDER_DAY_3: 'transition/mark-order-received-reminder-day-3',
  MARK_ORDER_RECEIVED_REMINDER_DAY_4: 'transition/mark-order-received-reminder-day-4',
  MARK_ORDER_RECEIVED_REMINDER_DAY_5: 'transition/mark-order-received-reminder-day-5',

  OPERATOR_REJECT_OFFER: 'transition/operator-reject-offer',
  OPERATOR_REJECT_CUSTOMER_COUNTER: 'transition/operator-reject-customer-counter',
  OPERATOR_CANCEL: 'transition/operator-cancel',
  OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_1:
    'transition/operator-cancel-from-delivery-reminder-day-1',
  OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_2:
    'transition/operator-cancel-from-delivery-reminder-day-2',
  OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_3:
    'transition/operator-cancel-from-delivery-reminder-day-3',
  OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_4:
    'transition/operator-cancel-from-delivery-reminder-day-4',
  OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_5:
    'transition/operator-cancel-from-delivery-reminder-day-5',
  OPERATOR_ACCEPT_DELIVERABLE: 'transition/operator-accept-deliverable',
  OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_1:
    'transition/operator-accept-deliverable-from-received-reminder-day-1',
  OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_2:
    'transition/operator-accept-deliverable-from-received-reminder-day-2',
  OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_3:
    'transition/operator-accept-deliverable-from-received-reminder-day-3',
  OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_4:
    'transition/operator-accept-deliverable-from-received-reminder-day-4',
  OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_5:
    'transition/operator-accept-deliverable-from-received-reminder-day-5',
  OPERATOR_DISPUTE: 'transition/operator-dispute',
  OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_1:
    'transition/operator-dispute-from-received-reminder-day-1',
  OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_2:
    'transition/operator-dispute-from-received-reminder-day-2',
  OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_3:
    'transition/operator-dispute-from-received-reminder-day-3',
  OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_4:
    'transition/operator-dispute-from-received-reminder-day-4',
  OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_5:
    'transition/operator-dispute-from-received-reminder-day-5',
  OPERATOR_CANCEL_FROM_DELIVERED: 'transition/operator-cancel-from-delivered',
  OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_1:
    'transition/operator-cancel-from-delivered-reminder-day-1',
  OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_2:
    'transition/operator-cancel-from-delivered-reminder-day-2',
  OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_3:
    'transition/operator-cancel-from-delivered-reminder-day-3',
  OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_4:
    'transition/operator-cancel-from-delivered-reminder-day-4',
  OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_5:
    'transition/operator-cancel-from-delivered-reminder-day-5',
  OPERATOR_ACCEPT_DELIVERABLE_FROM_DISPUTED: 'transition/operator-accept-deliverable-from-disputed',
  OPERATOR_CANCEL_FROM_DISPUTED: 'transition/operator-cancel-from-disputed',

  REVIEW_1_BY_PROVIDER: 'transition/review-1-by-provider',
  REVIEW_2_BY_PROVIDER: 'transition/review-2-by-provider',
  REVIEW_1_BY_CUSTOMER: 'transition/review-1-by-customer',
  REVIEW_2_BY_CUSTOMER: 'transition/review-2-by-customer',
  REVIEW_1_BY_PROVIDER_AFTER_PAYOUT_RELEASE: 'transition/review-1-by-provider-after-payout-release',
  REVIEW_2_BY_PROVIDER_AFTER_PAYOUT_RELEASE: 'transition/review-2-by-provider-after-payout-release',
  REVIEW_1_BY_CUSTOMER_AFTER_PAYOUT_RELEASE: 'transition/review-1-by-customer-after-payout-release',
  REVIEW_2_BY_CUSTOMER_AFTER_PAYOUT_RELEASE: 'transition/review-2-by-customer-after-payout-release',
  EXPIRE_REVIEW_PERIOD: 'transition/expire-review-period',
  EXPIRE_PROVIDER_REVIEW_PERIOD: 'transition/expire-provider-review-period',
  EXPIRE_CUSTOMER_REVIEW_PERIOD: 'transition/expire-customer-review-period',
  EXPIRE_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE: 'transition/expire-review-period-after-payout-release',
  EXPIRE_PROVIDER_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE:
    'transition/expire-provider-review-period-after-payout-release',
  EXPIRE_CUSTOMER_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE:
    'transition/expire-customer-review-period-after-payout-release',
  RELEASE_PAYOUT_FROM_ACCEPTED: 'transition/release-payout-from-accepted',
  MARK_PAYOUT_ELIGIBLE_FROM_ACCEPTED: 'transition/mark-payout-eligible-from-accepted',
  MARK_PAYOUT_FAILED_FROM_ACCEPTED: 'transition/mark-payout-failed-from-accepted',
  MARK_PAYOUT_BLOCKED_FROM_ACCEPTED: 'transition/mark-payout-blocked-from-accepted',
  RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_ACCEPTED:
    'transition/resolve-payout-blocked-to-pending-from-accepted',
  RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_ACCEPTED:
    'transition/resolve-payout-blocked-to-eligible-from-accepted',
  RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_ACCEPTED:
    'transition/resolve-payout-blocked-to-cancelled-from-accepted',
  RELEASE_PAYOUT_FROM_REVIEWED_BY_PROVIDER: 'transition/release-payout-from-reviewed-by-provider',
  MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED_BY_PROVIDER:
    'transition/mark-payout-eligible-from-reviewed-by-provider',
  MARK_PAYOUT_FAILED_FROM_REVIEWED_BY_PROVIDER:
    'transition/mark-payout-failed-from-reviewed-by-provider',
  MARK_PAYOUT_BLOCKED_FROM_REVIEWED_BY_PROVIDER:
    'transition/mark-payout-blocked-from-reviewed-by-provider',
  RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED_BY_PROVIDER:
    'transition/resolve-payout-blocked-to-pending-from-reviewed-by-provider',
  RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED_BY_PROVIDER:
    'transition/resolve-payout-blocked-to-eligible-from-reviewed-by-provider',
  RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED_BY_PROVIDER:
    'transition/resolve-payout-blocked-to-cancelled-from-reviewed-by-provider',
  RELEASE_PAYOUT_FROM_REVIEWED_BY_CUSTOMER: 'transition/release-payout-from-reviewed-by-customer',
  MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED_BY_CUSTOMER:
    'transition/mark-payout-eligible-from-reviewed-by-customer',
  MARK_PAYOUT_FAILED_FROM_REVIEWED_BY_CUSTOMER:
    'transition/mark-payout-failed-from-reviewed-by-customer',
  MARK_PAYOUT_BLOCKED_FROM_REVIEWED_BY_CUSTOMER:
    'transition/mark-payout-blocked-from-reviewed-by-customer',
  RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED_BY_CUSTOMER:
    'transition/resolve-payout-blocked-to-pending-from-reviewed-by-customer',
  RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED_BY_CUSTOMER:
    'transition/resolve-payout-blocked-to-eligible-from-reviewed-by-customer',
  RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED_BY_CUSTOMER:
    'transition/resolve-payout-blocked-to-cancelled-from-reviewed-by-customer',
  RELEASE_PAYOUT_FROM_REVIEWED: 'transition/release-payout-from-reviewed',
  MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED: 'transition/mark-payout-eligible-from-reviewed',
  MARK_PAYOUT_FAILED_FROM_REVIEWED: 'transition/mark-payout-failed-from-reviewed',
  MARK_PAYOUT_BLOCKED_FROM_REVIEWED: 'transition/mark-payout-blocked-from-reviewed',
  RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED:
    'transition/resolve-payout-blocked-to-pending-from-reviewed',
  RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED:
    'transition/resolve-payout-blocked-to-eligible-from-reviewed',
  RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED:
    'transition/resolve-payout-blocked-to-cancelled-from-reviewed',
};

/**
 * States (match process.edn :to values without :state/ prefix)
 */
export const states = {
  INITIAL: 'initial',
  OFFER_MADE_BY_PROVIDER: 'offer-made-by-provider',
  OFFER_MADE_BY_CUSTOMER: 'offer-made-by-customer',
  PENDING_PAYMENT: 'pending-payment',
  PENDING_PAYMENT_REMINDER_SENT: 'pending-payment-reminder-sent',
  PREAUTHORIZED: 'preauthorized',
  DELIVERED: 'delivered',
  DISPUTED: 'disputed',
  ACCEPTED: 'accepted',
  ACCEPTED_PAYOUT_RELEASED: 'accepted-payout-released',
  REVIEWED_BY_PROVIDER: 'reviewed-by-provider',
  REVIEWED_BY_PROVIDER_PAYOUT_RELEASED: 'reviewed-by-provider-payout-released',
  REVIEWED_BY_CUSTOMER: 'reviewed-by-customer',
  REVIEWED_BY_CUSTOMER_PAYOUT_RELEASED: 'reviewed-by-customer-payout-released',
  REVIEWED: 'reviewed',
  REVIEWED_PAYOUT_RELEASED: 'reviewed-payout-released',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
  PAYMENT_EXPIRED: 'payment-expired',
};

/**
 * Process graph (lastTransition -> current state)
 */
export const graph = {
  id: 'reverse-negotiation/release-1',
  initial: states.INITIAL,
  states: {
    [states.INITIAL]: {
      on: {
        [transitions.PROVIDER_OFFER]: states.OFFER_MADE_BY_PROVIDER,
      },
    },
    [states.OFFER_MADE_BY_PROVIDER]: {
      on: {
        [transitions.PROVIDER_WITHDRAW_OFFER]: states.CANCELLED,
        [transitions.CUSTOMER_COUNTER_OFFER]: states.OFFER_MADE_BY_CUSTOMER,
        [transitions.CUSTOMER_DECLINE_OFFER]: states.DECLINED,
        [transitions.CUSTOMER_WITHDRAW_COUNTER]: states.CANCELLED,
        [transitions.CUSTOMER_ACCEPT_OFFER]: states.PENDING_PAYMENT,
        [transitions.OPERATOR_REJECT_OFFER]: states.DECLINED,
      },
    },
    [states.OFFER_MADE_BY_CUSTOMER]: {
      on: {
        [transitions.PROVIDER_ACCEPT_COUNTER]: states.OFFER_MADE_BY_PROVIDER,
        [transitions.PROVIDER_COUNTER_OFFER]: states.OFFER_MADE_BY_PROVIDER,
        [transitions.PROVIDER_DECLINE_COUNTER]: states.DECLINED,
        [transitions.PROVIDER_WITHDRAW_COUNTER]: states.CANCELLED,
        [transitions.CUSTOMER_WITHDRAW_COUNTER_AFTER_COUNTER]: states.CANCELLED,
        [transitions.OPERATOR_REJECT_CUSTOMER_COUNTER]: states.DECLINED,
      },
    },
    [states.PENDING_PAYMENT]: {
      on: {
        [transitions.CONFIRM_PAYMENT]: states.PREAUTHORIZED,
        [transitions.PAYMENT_REMINDER_AFTER_15_MIN]: states.PENDING_PAYMENT_REMINDER_SENT,
        [transitions.EXPIRE_PAYMENT]: states.PAYMENT_EXPIRED,
      },
    },
    [states.PENDING_PAYMENT_REMINDER_SENT]: {
      on: {
        [transitions.CONFIRM_PAYMENT_AFTER_REMINDER]: states.PREAUTHORIZED,
        [transitions.EXPIRE_PAYMENT_AFTER_REMINDER]: states.PAYMENT_EXPIRED,
      },
    },
    [states.PAYMENT_EXPIRED]: {},
    [states.PREAUTHORIZED]: {
      on: {
        [transitions.PROVIDER_MARK_DELIVERED]: states.DELIVERED,
        [transitions.OPERATOR_MARK_DELIVERED]: states.DELIVERED,
        [transitions.PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_1]: states.DELIVERED,
        [transitions.PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_2]: states.DELIVERED,
        [transitions.PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_3]: states.DELIVERED,
        [transitions.PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_4]: states.DELIVERED,
        [transitions.PROVIDER_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_5]: states.DELIVERED,
        [transitions.OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_1]: states.DELIVERED,
        [transitions.OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_2]: states.DELIVERED,
        [transitions.OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_3]: states.DELIVERED,
        [transitions.OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_4]: states.DELIVERED,
        [transitions.OPERATOR_MARK_DELIVERED_FROM_DELIVERY_REMINDER_DAY_5]: states.DELIVERED,
        [transitions.DELIVERY_REMINDER_DAY_1]: states.PREAUTHORIZED,
        [transitions.DELIVERY_REMINDER_DAY_2]: states.PREAUTHORIZED,
        [transitions.DELIVERY_REMINDER_DAY_3]: states.PREAUTHORIZED,
        [transitions.DELIVERY_REMINDER_DAY_4]: states.PREAUTHORIZED,
        [transitions.DELIVERY_REMINDER_DAY_5]: states.PREAUTHORIZED,
        [transitions.OPERATOR_CANCEL]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_1]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_2]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_3]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_4]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERY_REMINDER_DAY_5]: states.CANCELLED,
        [transitions.AUTO_CANCEL_AFTER_14_DAYS]: states.CANCELLED,
        [transitions.AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_1]: states.CANCELLED,
        [transitions.AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_2]: states.CANCELLED,
        [transitions.AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_3]: states.CANCELLED,
        [transitions.AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_4]: states.CANCELLED,
        [transitions.AUTO_CANCEL_AFTER_14_DAYS_FROM_DELIVERY_REMINDER_DAY_5]: states.CANCELLED,
      },
    },
    [states.DELIVERED]: {
      on: {
        [transitions.CUSTOMER_ACCEPT_DELIVERABLE]: states.ACCEPTED,
        [transitions.CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_1]: states.ACCEPTED,
        [transitions.CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_2]: states.ACCEPTED,
        [transitions.CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_3]: states.ACCEPTED,
        [transitions.CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_4]: states.ACCEPTED,
        [transitions.CUSTOMER_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_5]: states.ACCEPTED,
        [transitions.DISPUTE]: states.DISPUTED,
        [transitions.CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_1]: states.DISPUTED,
        [transitions.CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_2]: states.DISPUTED,
        [transitions.CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_3]: states.DISPUTED,
        [transitions.CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_4]: states.DISPUTED,
        [transitions.CUSTOMER_DISPUTE_FROM_RECEIVED_REMINDER_DAY_5]: states.DISPUTED,
        [transitions.OPERATOR_ACCEPT_DELIVERABLE]: states.ACCEPTED,
        [transitions.OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_1]: states.ACCEPTED,
        [transitions.OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_2]: states.ACCEPTED,
        [transitions.OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_3]: states.ACCEPTED,
        [transitions.OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_4]: states.ACCEPTED,
        [transitions.OPERATOR_ACCEPT_DELIVERABLE_FROM_RECEIVED_REMINDER_DAY_5]: states.ACCEPTED,
        [transitions.OPERATOR_DISPUTE]: states.DISPUTED,
        [transitions.OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_1]: states.DISPUTED,
        [transitions.OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_2]: states.DISPUTED,
        [transitions.OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_3]: states.DISPUTED,
        [transitions.OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_4]: states.DISPUTED,
        [transitions.OPERATOR_DISPUTE_FROM_RECEIVED_REMINDER_DAY_5]: states.DISPUTED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERED]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_1]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_2]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_3]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_4]: states.CANCELLED,
        [transitions.OPERATOR_CANCEL_FROM_DELIVERED_REMINDER_DAY_5]: states.CANCELLED,
        [transitions.MARK_ORDER_RECEIVED_REMINDER_DAY_1]: states.DELIVERED,
        [transitions.MARK_ORDER_RECEIVED_REMINDER_DAY_2]: states.DELIVERED,
        [transitions.MARK_ORDER_RECEIVED_REMINDER_DAY_3]: states.DELIVERED,
        [transitions.MARK_ORDER_RECEIVED_REMINDER_DAY_4]: states.DELIVERED,
        [transitions.MARK_ORDER_RECEIVED_REMINDER_DAY_5]: states.DELIVERED,
      },
    },
    [states.DISPUTED]: {
      on: {
        [transitions.OPERATOR_ACCEPT_DELIVERABLE_FROM_DISPUTED]: states.ACCEPTED,
        [transitions.OPERATOR_CANCEL_FROM_DISPUTED]: states.CANCELLED,
      },
    },
    [states.ACCEPTED]: {
      on: {
        [transitions.REVIEW_1_BY_PROVIDER]: states.REVIEWED_BY_PROVIDER,
        [transitions.REVIEW_1_BY_CUSTOMER]: states.REVIEWED_BY_CUSTOMER,
        [transitions.EXPIRE_REVIEW_PERIOD]: states.REVIEWED,
        [transitions.RELEASE_PAYOUT_FROM_ACCEPTED]: states.ACCEPTED_PAYOUT_RELEASED,
        [transitions.MARK_PAYOUT_ELIGIBLE_FROM_ACCEPTED]: states.ACCEPTED,
        [transitions.MARK_PAYOUT_FAILED_FROM_ACCEPTED]: states.ACCEPTED,
        [transitions.MARK_PAYOUT_BLOCKED_FROM_ACCEPTED]: states.ACCEPTED,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_ACCEPTED]: states.ACCEPTED,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_ACCEPTED]:
          states.ACCEPTED_PAYOUT_RELEASED,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_ACCEPTED]: states.CANCELLED,
      },
    },
    [states.ACCEPTED_PAYOUT_RELEASED]: {
      on: {
        [transitions.REVIEW_1_BY_PROVIDER_AFTER_PAYOUT_RELEASE]:
          states.REVIEWED_BY_PROVIDER_PAYOUT_RELEASED,
        [transitions.REVIEW_1_BY_CUSTOMER_AFTER_PAYOUT_RELEASE]:
          states.REVIEWED_BY_CUSTOMER_PAYOUT_RELEASED,
        [transitions.EXPIRE_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE]: states.REVIEWED_PAYOUT_RELEASED,
      },
    },
    [states.REVIEWED_BY_PROVIDER]: {
      on: {
        [transitions.REVIEW_2_BY_CUSTOMER]: states.REVIEWED,
        [transitions.EXPIRE_CUSTOMER_REVIEW_PERIOD]: states.REVIEWED,
        [transitions.RELEASE_PAYOUT_FROM_REVIEWED_BY_PROVIDER]: states.REVIEWED_PAYOUT_RELEASED,
        [transitions.MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED_BY_PROVIDER]: states.REVIEWED_BY_PROVIDER,
        [transitions.MARK_PAYOUT_FAILED_FROM_REVIEWED_BY_PROVIDER]: states.REVIEWED_BY_PROVIDER,
        [transitions.MARK_PAYOUT_BLOCKED_FROM_REVIEWED_BY_PROVIDER]: states.REVIEWED_BY_PROVIDER,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED_BY_PROVIDER]:
          states.REVIEWED_BY_PROVIDER,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED_BY_PROVIDER]:
          states.REVIEWED_PAYOUT_RELEASED,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED_BY_PROVIDER]:
          states.CANCELLED,
      },
    },
    [states.REVIEWED_BY_PROVIDER_PAYOUT_RELEASED]: {
      on: {
        [transitions.REVIEW_2_BY_CUSTOMER_AFTER_PAYOUT_RELEASE]: states.REVIEWED_PAYOUT_RELEASED,
        [transitions.EXPIRE_CUSTOMER_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE]:
          states.REVIEWED_PAYOUT_RELEASED,
      },
    },
    [states.REVIEWED_BY_CUSTOMER]: {
      on: {
        [transitions.REVIEW_2_BY_PROVIDER]: states.REVIEWED,
        [transitions.EXPIRE_PROVIDER_REVIEW_PERIOD]: states.REVIEWED,
        [transitions.RELEASE_PAYOUT_FROM_REVIEWED_BY_CUSTOMER]: states.REVIEWED_PAYOUT_RELEASED,
        [transitions.MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED_BY_CUSTOMER]: states.REVIEWED_BY_CUSTOMER,
        [transitions.MARK_PAYOUT_FAILED_FROM_REVIEWED_BY_CUSTOMER]: states.REVIEWED_BY_CUSTOMER,
        [transitions.MARK_PAYOUT_BLOCKED_FROM_REVIEWED_BY_CUSTOMER]: states.REVIEWED_BY_CUSTOMER,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED_BY_CUSTOMER]:
          states.REVIEWED_BY_CUSTOMER,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED_BY_CUSTOMER]:
          states.REVIEWED_PAYOUT_RELEASED,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED_BY_CUSTOMER]:
          states.CANCELLED,
      },
    },
    [states.REVIEWED_BY_CUSTOMER_PAYOUT_RELEASED]: {
      on: {
        [transitions.REVIEW_2_BY_PROVIDER_AFTER_PAYOUT_RELEASE]: states.REVIEWED_PAYOUT_RELEASED,
        [transitions.EXPIRE_PROVIDER_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE]:
          states.REVIEWED_PAYOUT_RELEASED,
      },
    },
    [states.REVIEWED]: {
      on: {
        [transitions.RELEASE_PAYOUT_FROM_REVIEWED]: states.REVIEWED_PAYOUT_RELEASED,
        [transitions.MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED]: states.REVIEWED,
        [transitions.MARK_PAYOUT_FAILED_FROM_REVIEWED]: states.REVIEWED,
        [transitions.MARK_PAYOUT_BLOCKED_FROM_REVIEWED]: states.REVIEWED,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED]: states.REVIEWED,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED]:
          states.REVIEWED_PAYOUT_RELEASED,
        [transitions.RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED]: states.CANCELLED,
      },
      type: 'final',
    },
    [states.REVIEWED_PAYOUT_RELEASED]: {
      type: 'final',
    },
    [states.DECLINED]: {},
    [states.CANCELLED]: {},
  },
};

export const isRelevantPastTransition = transition => {
  return [
    transitions.PROVIDER_OFFER,
    transitions.PROVIDER_WITHDRAW_OFFER,
    transitions.CUSTOMER_COUNTER_OFFER,
    transitions.CUSTOMER_DECLINE_OFFER,
    transitions.CUSTOMER_WITHDRAW_COUNTER,
    transitions.CUSTOMER_WITHDRAW_COUNTER_AFTER_COUNTER,
    transitions.CUSTOMER_ACCEPT_OFFER,
    transitions.PROVIDER_ACCEPT_COUNTER,
    transitions.PROVIDER_COUNTER_OFFER,
    transitions.PROVIDER_DECLINE_COUNTER,
    transitions.PROVIDER_WITHDRAW_COUNTER,
    transitions.CONFIRM_PAYMENT,
    transitions.CONFIRM_PAYMENT_AFTER_REMINDER,
    transitions.EXPIRE_PAYMENT,
    transitions.EXPIRE_PAYMENT_AFTER_REMINDER,
    transitions.PROVIDER_MARK_DELIVERED,
    transitions.OPERATOR_MARK_DELIVERED,
    transitions.CUSTOMER_ACCEPT_DELIVERABLE,
    transitions.DISPUTE,
    transitions.OPERATOR_ACCEPT_DELIVERABLE,
    transitions.OPERATOR_DISPUTE,
    transitions.OPERATOR_CANCEL_FROM_DELIVERED,
    transitions.OPERATOR_ACCEPT_DELIVERABLE_FROM_DISPUTED,
    transitions.OPERATOR_CANCEL_FROM_DISPUTED,
    transitions.REVIEW_1_BY_PROVIDER,
    transitions.REVIEW_2_BY_PROVIDER,
    transitions.REVIEW_1_BY_CUSTOMER,
    transitions.REVIEW_2_BY_CUSTOMER,
    transitions.REVIEW_1_BY_PROVIDER_AFTER_PAYOUT_RELEASE,
    transitions.REVIEW_2_BY_PROVIDER_AFTER_PAYOUT_RELEASE,
    transitions.REVIEW_1_BY_CUSTOMER_AFTER_PAYOUT_RELEASE,
    transitions.REVIEW_2_BY_CUSTOMER_AFTER_PAYOUT_RELEASE,
    transitions.RELEASE_PAYOUT_FROM_ACCEPTED,
    transitions.MARK_PAYOUT_ELIGIBLE_FROM_ACCEPTED,
    transitions.MARK_PAYOUT_FAILED_FROM_ACCEPTED,
    transitions.MARK_PAYOUT_BLOCKED_FROM_ACCEPTED,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_ACCEPTED,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_ACCEPTED,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_ACCEPTED,
    transitions.RELEASE_PAYOUT_FROM_REVIEWED_BY_PROVIDER,
    transitions.MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED_BY_PROVIDER,
    transitions.MARK_PAYOUT_FAILED_FROM_REVIEWED_BY_PROVIDER,
    transitions.MARK_PAYOUT_BLOCKED_FROM_REVIEWED_BY_PROVIDER,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED_BY_PROVIDER,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED_BY_PROVIDER,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED_BY_PROVIDER,
    transitions.RELEASE_PAYOUT_FROM_REVIEWED_BY_CUSTOMER,
    transitions.MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED_BY_CUSTOMER,
    transitions.MARK_PAYOUT_FAILED_FROM_REVIEWED_BY_CUSTOMER,
    transitions.MARK_PAYOUT_BLOCKED_FROM_REVIEWED_BY_CUSTOMER,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED_BY_CUSTOMER,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED_BY_CUSTOMER,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED_BY_CUSTOMER,
    transitions.RELEASE_PAYOUT_FROM_REVIEWED,
    transitions.MARK_PAYOUT_ELIGIBLE_FROM_REVIEWED,
    transitions.MARK_PAYOUT_FAILED_FROM_REVIEWED,
    transitions.MARK_PAYOUT_BLOCKED_FROM_REVIEWED,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_PENDING_FROM_REVIEWED,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_ELIGIBLE_FROM_REVIEWED,
    transitions.RESOLVE_PAYOUT_BLOCKED_TO_CANCELLED_FROM_REVIEWED,
    transitions.EXPIRE_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE,
    transitions.EXPIRE_PROVIDER_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE,
    transitions.EXPIRE_CUSTOMER_REVIEW_PERIOD_AFTER_PAYOUT_RELEASE,
  ].includes(transition);
};

export const isCustomerReview = transition => {
  return [
    transitions.REVIEW_1_BY_CUSTOMER,
    transitions.REVIEW_2_BY_CUSTOMER,
    transitions.REVIEW_1_BY_CUSTOMER_AFTER_PAYOUT_RELEASE,
    transitions.REVIEW_2_BY_CUSTOMER_AFTER_PAYOUT_RELEASE,
  ].includes(transition);
};

export const isProviderReview = transition => {
  return [
    transitions.REVIEW_1_BY_PROVIDER,
    transitions.REVIEW_2_BY_PROVIDER,
    transitions.REVIEW_1_BY_PROVIDER_AFTER_PAYOUT_RELEASE,
    transitions.REVIEW_2_BY_PROVIDER_AFTER_PAYOUT_RELEASE,
  ].includes(transition);
};

/** Customer-accept-offer is privileged (backend sets line items + creates payment intent) */
export const isPrivileged = transition => {
  return transition === transitions.CUSTOMER_ACCEPT_OFFER;
};

export const isCompleted = transition => {
  return [
    transitions.CUSTOMER_ACCEPT_DELIVERABLE,
    transitions.OPERATOR_ACCEPT_DELIVERABLE,
    transitions.OPERATOR_ACCEPT_DELIVERABLE_FROM_DISPUTED,
  ].includes(transition);
};

export const isRefunded = transition => {
  return [
    transitions.EXPIRE_PAYMENT,
    transitions.OPERATOR_CANCEL,
    transitions.OPERATOR_CANCEL_FROM_DELIVERED,
    transitions.OPERATOR_CANCEL_FROM_DISPUTED,
    transitions.AUTO_CANCEL_AFTER_14_DAYS,
  ].includes(transition);
};

export const statesNeedingCustomerAttention = [
  states.OFFER_MADE_BY_PROVIDER,
  states.PENDING_PAYMENT,
  states.PENDING_PAYMENT_REMINDER_SENT,
  states.DELIVERED,
  states.DISPUTED,
];

export const statesNeedingProviderAttention = [states.OFFER_MADE_BY_CUSTOMER, states.PREAUTHORIZED];
